module.exports = __webpack_public_path__ + "static/img/Parametric Studies 5 - Economics.e71e55f.png";